import { render, staticRenderFns } from "./AddMember.vue?vue&type=template&id=22f8bb94&scoped=true"
import script from "./AddMember.vue?vue&type=script&lang=js"
export * from "./AddMember.vue?vue&type=script&lang=js"
import style0 from "./AddMember.vue?vue&type=style&index=0&id=22f8bb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f8bb94",
  null
  
)

export default component.exports